import * as particles from 'pixi-particles'

export class MixHelper {
    public static toggleAnim(state: boolean, container) {
        const emitter = new particles.Emitter(
            container,
            null,
            {
                "alpha": {
                    "start": 0.82,
                    "end": 0
                },
                "scale": {
                    "start": 2,
                    "end": 0.4,
                    "minimumScaleMultiplier": 1
                },
                "color": {
                    "start": "#fc2561",
                    "end": "#f0136b"
                },
                "speed": {
                    "start": 10,
                    "end": 10,
                    "minimumSpeedMultiplier": 1
                },
                "acceleration": {
                    "x": 0,
                    "y": 0
                },
                "maxSpeed": 0,
                "startRotation": {
                    "min": 0,
                    "max": 360
                },
                "noRotation": false,
                "rotationSpeed": {
                    "min": 0,
                    "max": 0
                },
                "lifetime": {
                    "min": 4,
                    "max": 1.8
                },
                "blendMode": "screen",
                "frequency": 0.01,
                "emitterLifetime": -1,
                "maxParticles": 1000,
                "pos": {
                    "x": 0.5,
                    "y": 0.5
                },
                "addAtBack": true,
                "spawnType": "circle",
                "spawnCircle": {
                    "x": 0,
                    "y": 0,
                    "r": 150
                }
            }
        )
        // var elapsed = Date.now();
        // var update = function(){

        //     // Update the next frame
        //     requestAnimationFrame(update);

        //     var now = Date.now();

        //     // The emitter requires the elapsed
        //     // number of seconds since the last update
        //     emitter.update((now - elapsed) * 0.001);
        //     elapsed = now;

        //     // Should re-render the PIXI Stage
        //     // renderer.render(stage);
        // };

        // // Start emitting
        // emitter.emit = true;

        // // Start the update
        // update();
        emitter.update(1);
    }
}